/**
 * Extracts a readable error message from various error response formats
 * @param error The error object from API response
 * @returns A user-friendly error message
 */
export const getErrorMessage = (error: any): string => {
  console.log("ovde", error);
  if (error?.errors) {
    const errorKeys = Object.keys(error.errors);
    if (errorKeys.length > 0) {
      
      const firstErrorKey = errorKeys[0];
      const errorMessages = error.errors[firstErrorKey];
      
      if (Array.isArray(errorMessages) && errorMessages.length > 0) {
        return errorMessages[0];
      } else if (typeof errorMessages === 'string') {
        return errorMessages;
      }
    }
  }
  
  if (error?.detail) {
    return error.detail;
  }
  
  if (error?.title) {
    return error.title;
  }
  
  if (error && typeof error.message === 'string') {
    return error.message;
  }
  
  return 'An error occurred. Please try again.';
};


/**
 * @param apiResponse The response from RTK Query (could be error or data)
 * @returns Formatted error message or null if no error
 */
export const handleApiError = (apiResponse: any): string | null => {
  if (apiResponse?.error) {
    const errorData = apiResponse.error.data;
    return getErrorMessage(errorData);
  }
  
  return null;
};